<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <ListPageShell>
    <template #header>
      <div class="list-page-panel is-header-minimal">
        <div class="list-page-heading">
          <div class="list-page-heading-main">
            <h1 class="list-page-title">加盟商产品授权管理</h1>
            <p class="list-page-description">
              管理加盟商的产品授权，包括授权产品的查看、添加和取消
            </p>
          </div>
          
        </div>
      </div>
    </template>
    <div class="min-h-full overflow-x-hidden bg-gradient-to-br from-slate-50 via-white to-slate-100">
    <div class="relative overflow-hidden">
      <div class="pointer-events-none absolute -right-40 -top-24 h-72 w-72 rounded-full bg-primary-100/60 blur-3xl"></div>
      <div class="pointer-events-none absolute left-10 top-36 h-40 w-40 rounded-full bg-slate-200/60 blur-3xl"></div>

      <div class="mx-auto w-full px-4 py-6">

        <div class="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <!-- 左侧：类目列表 -->
          <div class="lg:col-span-3">
            <ProductCategorySidebar
              :categories="categories"
              :loading="categoryLoading"
              :selected-category-id="selectedCategory"
              title="产品类目"
              description="选择类目可筛选产品"
              :show-add-button="false"
              :show-actions="false"
              @select="applyCategoryFilter"
            />
          </div>

          <!-- 右侧：产品列表 -->
          <div class="lg:col-span-9">
            <div class="list-page-table-panel">
              <div class="border-b border-slate-200 p-5">
                <div class="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
                  <div>
                    <h2 class="text-base font-semibold text-slate-900">产品授权列表</h2>
                    <p class="mt-1 text-xs text-slate-500">选择加盟商后，可进行产品授权管理</p>
                  </div>
                  <div class="flex flex-wrap items-center gap-2">
                    <el-select
                      v-model="selectedFranchiseeId"
                      placeholder="请选择加盟商"
                      filterable
                      clearable
                      class="w-[220px]"
                      @change="handleFranchiseeChange"
                    >
                      <el-option
                        v-for="f in franchisees"
                        :key="f.id"
                        :label="f.name"
                        :value="f.id"
                      />
                    </el-select>
                    <button
                      v-if="selectedProductIds.length > 0"
                      v-permission="'franchisee:authorize'"
                      @click="batchRevoke"
                      :loading="authorizeLoading"
                      class="rounded-lg bg-red-600 px-3 py-1.5 text-xs text-white hover:bg-red-700"
                    >
                      取消授权 ({{ selectedProductIds.length }})
                    </button>
                    <button
                      v-permission="'franchisee:authorize'"
                      @click="openAddModal"
                      :disabled="!selectedFranchiseeId"
                      class="flex items-center gap-2 rounded-lg bg-primary-600 px-3 py-1.5 text-xs text-white hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      <svg class="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
                      </svg>
                      新增授权
                    </button>
                  </div>
                </div>

                <PageFilterBar
                  shell-class="filter-bar-shell is-embedded"
                  body-class="filter-bar-body is-embedded"
                  :show-refresh="true"
                  :refresh-loading="loading"
                  @refresh="loadProducts"
                >
                  <div class="filter-bar-field is-wide relative">
                    <input
                      v-model="searchForm.keyword"
                      type="text"
                      placeholder="搜索产品名称或编码"
                      class="form-search-input form-control-sm w-full"
                    >
                    <svg class="absolute left-3 top-2.5 h-4 w-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                  </div>
                  <el-select v-model="searchForm.categoryId" placeholder="请选择类目" class="form-select form-control-sm filter-bar-field">
                    <el-option label="全部类目" :value="null" />
                    <el-option v-for="cat in categories" :key="cat.id" :label="cat.name" :value="cat.id" />
                  </el-select>

                  <template #searchActions>
                    <button
                      @click="handleSearch"
                      class="btn-primary"
                    >
                      搜索
                    </button>
                    <button
                      @click="handleReset"
                      class="btn-secondary"
                    >
                      重置
                    </button>
                  </template>
                </PageFilterBar>
              </div>

              <div class="data-table-shell">
                <div class="data-table-scroll">
                <table class="data-table text-sm">
                  <thead class="data-table-head">
                    <tr>
                      <th class="data-table-th text-left w-10">
                        <input
                          type="checkbox"
                          :checked="isAllSelected"
                          :indeterminate="isIndeterminate"
                          @change="toggleSelectAll"
                          class="form-check"
                        >
                      </th>
                      <th class="data-table-th text-left">产品名称</th>
                      <th class="data-table-th text-left">摘要</th>
                      <th class="data-table-th is-right">展示价</th>
                      <th class="data-table-th is-center">周期(天)</th>
                      <th class="data-table-th is-center">状态</th>
                      <th class="data-table-th text-left">类型</th>
                      <th class="data-table-th is-center">操作</th>
                    </tr>
                  </thead>
                  <tbody class="data-table-body">
                    <!-- 骨架屏加载状态 -->
                    <template v-if="loading">
                      <tr v-for="n in 5" :key="n" class="animate-pulse">
                        <td class="data-table-td"><div class="w-4 h-4 bg-slate-200 rounded"></div></td>
                        <td class="data-table-td">
                          <div class="flex items-center gap-3">
                            <div class="w-10 h-10 bg-slate-200 rounded-lg"></div>
                            <div>
                              <div class="h-4 w-32 bg-slate-200 rounded mb-1"></div>
                              <div class="h-3 w-24 bg-slate-200 rounded"></div>
                            </div>
                          </div>
                        </td>
                        <td class="data-table-td"><div class="h-4 w-24 bg-slate-200 rounded"></div></td>
                        <td class="data-table-td is-right"><div class="h-4 w-20 bg-slate-200 rounded ml-auto"></div></td>
                        <td class="data-table-td is-center"><div class="h-4 w-12 bg-slate-200 rounded mx-auto"></div></td>
                        <td class="data-table-td is-center"><div class="h-6 w-14 bg-slate-200 rounded-full mx-auto"></div></td>
                        <td class="data-table-td"><div class="h-4 w-16 bg-slate-200 rounded"></div></td>
                        <td class="data-table-td">
                          <div class="flex items-center justify-center gap-2">
                            <div class="h-8 w-8 bg-slate-200 rounded"></div>
                            <div class="h-8 w-8 bg-slate-200 rounded"></div>
                          </div>
                        </td>
                      </tr>
                    </template>
                    <!-- 空状态 -->
                    <tr v-if="!loading && products.length === 0">
                      <td colspan="8" class="data-table-empty text-sm text-slate-500">
                        <div v-if="!selectedFranchiseeId" class="flex flex-col items-center">
                          <svg class="w-12 h-12 text-slate-300 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
                          </svg>
                          <p>请先选择加盟商</p>
                        </div>
                        <div v-else class="flex flex-col items-center">
                          <svg class="w-12 h-12 text-slate-300 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/>
                          </svg>
                          <p>暂无产品数据</p>
                        </div>
                      </td>
                    </tr>
                    <tr v-for="product in products" :key="product.id" class="data-table-row">
                      <td class="data-table-td">
                        <input
                          type="checkbox"
                          :checked="selectedProductIds.includes(product.id)"
                          @change="toggleSelect(product.id)"
                          class="form-check"
                        >
                      </td>
                      <td class="data-table-td">
                        <div class="data-table-cell-title">{{ product.name }}</div>
                        <div class="data-table-cell-meta">{{ product.shortName || product.code }}</div>
                      </td>
                      <td class="data-table-td text-slate-600">{{ product.summary || '-' }}</td>
                      <td class="data-table-td is-right font-medium text-primary-600">{{ product.priceDisplay || '-' }}</td>
                      <td class="data-table-td is-center text-slate-600">{{ product.durationDays ?? '-' }}</td>
                      <td class="data-table-td is-center">
                        <span
                          :class="[
                            'status-badge',
                            product.status === 1 ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-600'
                          ]"
                        >
                          {{ product.status === 1 ? '上架' : '下架' }}
                        </span>
                      </td>
                      <td class="data-table-td text-slate-600">{{ categoryName(product.categoryId) }}</td>
                      <td class="data-table-td">
                        <div class="flex items-center justify-center gap-2">
                          <button
                            @click="handleViewDetail(product)"
                            class="table-action-button is-primary"
                            title="查看详情" aria-label="查看详情"
                          >
                            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                            </svg>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                </div>
              </div>
              <AppPagination
                v-if="pagination.total > 0"
                class="pagination-bridge"
                :pagination="pagination"
                :page-sizes="[10, 20, 50]"
                @page-change="handlePageChange"
                @size-change="handlePageSizeChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 新增授权弹窗 -->
    <ProductSelector
      v-model:visible="showAddModal"
      v-model="addSelectedProductIds"
      :product-tree="unauthorizedProductTree"
      title="新增产品授权"
      :description="authorizeDescription"
      @confirm="handleAuthorizeConfirm"
    />

    <!-- 产品详情弹窗 -->
    <ProductDetailModal
      v-model="showDetailModal"
      :product-id="selectedProductId"
      :categories="categories"
    />
    </div>
  </ListPageShell>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue'
import ProductCategorySidebar from '@/components/ProductCategorySidebar.vue'
import ProductSelector from './components/ProductSelector.vue'
import ProductDetailModal from '@/components/ProductDetailModal.vue'
import AppPagination from '@/components/AppPagination.vue'
import ListPageShell from '@/components/ListPageShell.vue'
import PageFilterBar from '@/components/PageFilterBar.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import {
  getFranchiseePage,
  authorizeProducts,
  revokeProducts
} from '@/api'
import {
  getProductPage,
  getProductCategories,
  getUnauthorizedProductTree
} from '@/api/product'

// 加载状态
const loading = ref(false)
const categoryLoading = ref(false)
const authorizeLoading = ref(false)
const selectorLoading = ref(false)

// 加盟商列表
const franchisees = ref([])
const selectedFranchiseeId = ref(null)
const selectedFranchiseeName = computed(() => {
  const franchisee = franchisees.value.find(f => f.id === selectedFranchiseeId.value)
  return franchisee?.name || ''
})
const authorizeDescription = computed(() => {
  return `为加盟商 "${selectedFranchiseeName.value}" 选择要授权的产品`
})

// 产品类目
const categories = ref([])
const allCategories = ref([])

// 产品列表
const products = ref([])

// 搜索表单
const searchForm = reactive({
  categoryId: null,
  keyword: ''
})

const selectedCategory = ref('')

// 分页
const pagination = reactive({
  current: 1,
  size: 10,
  total: 0,
  pages: 0,
  hasNext: false,
  hasPrevious: false
})

// 选中产品
const selectedProductIds = ref([])
const isAllSelected = computed(() => {
  return products.value.length > 0 && selectedProductIds.value.length === products.value.length
})
const isIndeterminate = computed(() => {
  return selectedProductIds.value.length > 0 && selectedProductIds.value.length < products.value.length
})

// 新增授权弹窗
const showAddModal = ref(false)
const unauthorizedProductTree = ref([])
const addSelectedProductIds = ref([])

// 产品详情弹窗
const showDetailModal = ref(false)
const selectedProductId = ref(null)

// 加载加盟商列表
const loadFranchisees = async () => {
  try {
    const res = await getFranchiseePage({ statuses: [3], current: 1, size: 999 })
    franchisees.value = res.records || []
  } catch (error) {
    console.error('加载加盟商列表失败:', error)
  }
}

// 加载类目
const loadCategories = async () => {
  categoryLoading.value = true
  try {
    const res = await getProductCategories()
    categories.value = res || []
    allCategories.value = res || []
  } catch (error) {
    console.error('加载类目失败:', error)
  } finally {
    categoryLoading.value = false
  }
}

// 加载产品列表
const loadProducts = async () => {
  // 必须先选择加盟商
  if (!selectedFranchiseeId.value) {
    products.value = []
    pagination.total = 0
    pagination.current = 1
    return
  }

  loading.value = true
  try {
    const params = {
      tenantId: selectedFranchiseeId.value,
      categoryId: searchForm.categoryId || undefined,
      keyword: searchForm.keyword || undefined,
      status: 1, // 只查询上架的产品
      page: pagination.current,
      size: pagination.size
    }
    const res = await getProductPage(params)
    products.value = res.records || []
    pagination.total = res.total || 0
    pagination.pages = res.pages || 0
    pagination.hasNext = res.hasNext || false
    pagination.hasPrevious = res.hasPrevious || false
  } catch (error) {
    console.error('加载产品列表失败:', error)
    ElMessage.error('加载产品列表失败')
  } finally {
    loading.value = false
  }
}

// 搜索
const handleSearch = () => {
  pagination.current = 1
  loadProducts()
}

// 重置
const handleReset = () => {
  selectedCategory.value = ''
  searchForm.categoryId = null
  searchForm.keyword = ''
  pagination.current = 1
  loadProducts()
}

// 获取类别名称
const categoryName = (categoryId) => {
  const category = categories.value.find(item => item.id === categoryId)
  return category ? category.name : '-'
}

const applyCategoryFilter = async (categoryId) => {
  const nextValue = String(categoryId)
  selectedCategory.value = selectedCategory.value === nextValue ? '' : nextValue
  searchForm.categoryId = selectedCategory.value ? Number(selectedCategory.value) : null
  await loadProducts(1)
}

// 分页切换
const handlePageChange = (page) => {
  if (page < 1 || page > pagination.pages) return
  pagination.current = page
  loadProducts()
}

const handlePageSizeChange = (size) => {
  pagination.size = size
  pagination.current = 1
  loadProducts()
}

// 加盟商选择变化
const handleFranchiseeChange = async () => {
  selectedProductIds.value = []
  pagination.current = 1
  if (selectedFranchiseeId.value) {
    await loadProducts()
  } else {
    products.value = []
  }
}

// 选择产品
const toggleSelect = (productId) => {
  const index = selectedProductIds.value.indexOf(productId)
  if (index > -1) {
    selectedProductIds.value.splice(index, 1)
  } else {
    selectedProductIds.value.push(productId)
  }
}

// 全选/取消全选
const toggleSelectAll = () => {
  if (isAllSelected.value) {
    selectedProductIds.value = []
  } else {
    selectedProductIds.value = products.value.map(p => p.id)
  }
}

// 打开新增授权弹窗
const openAddModal = async () => {
  addSelectedProductIds.value = []
  showAddModal.value = true
  // 加载未授权产品树
  if (selectedFranchiseeId.value) {
    selectorLoading.value = true
    try {
      const res = await getUnauthorizedProductTree(selectedFranchiseeId.value)
      unauthorizedProductTree.value = res || []
    } catch (error) {
      console.error('加载未授权产品失败:', error)
      ElMessage.error('加载未授权产品失败')
      unauthorizedProductTree.value = []
    } finally {
      selectorLoading.value = false
    }
  }
}

// 处理授权确认
const handleAuthorizeConfirm = async (selectedIds) => {
  if (selectedIds.length === 0) return
  authorizeLoading.value = true
  try {
    await authorizeProducts(selectedFranchiseeId.value, selectedIds)
    ElMessage.success(`成功授权 ${selectedIds.length} 个产品`)
    showAddModal.value = false
    await loadProducts()
  } catch (error) {
    console.error('授权失败:', error)
    ElMessage.error(error.message || '授权失败')
  } finally {
    authorizeLoading.value = false
  }
}

// 批量取消授权
const batchRevoke = async () => {
  if (selectedProductIds.value.length === 0) return
  try {
    await ElMessageBox.confirm(
      `确定要取消该加盟商的 ${selectedProductIds.value.length} 个产品授权吗？`,
      '取消授权确认',
      { type: 'warning' }
    )
    authorizeLoading.value = true
    await revokeProducts(selectedFranchiseeId.value, selectedProductIds.value)
    ElMessage.success(`成功取消 ${selectedProductIds.value.length} 个产品授权`)
    selectedProductIds.value = []
    await loadProducts()
  } catch (error) {
    if (error !== 'cancel') {
      console.error('取消授权失败:', error)
      ElMessage.error('取消授权失败')
    }
  } finally {
    authorizeLoading.value = false
  }
}

// 查看详情
const handleViewDetail = (product) => {
  console.log('handleViewDetail called:', product)
  selectedProductId.value = product.id
  showDetailModal.value = true
  console.log('selectedProductId:', selectedProductId.value, 'showDetailModal:', showDetailModal.value)
}

// 初始化
onMounted(() => {
  loadFranchisees()
  loadCategories()
})
</script>
